import { useState, useEffect, useCallback } from 'react';
import { timelineEvents } from '../data/timelineEvents';

export function useTimelineScroll() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [pauseTimeout, setPauseTimeout] = useState(null);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prev) => (prev + 1) % timelineEvents.length);
  }, []);

  // Handle manual navigation
  const handleIndexChange = useCallback((newIndex) => {
    setCurrentIndex(newIndex);
    setIsPaused(true);
    
    // Clear existing timeout if any
    if (pauseTimeout) {
      clearTimeout(pauseTimeout);
    }
    
    // Resume auto-scroll after 1 minute
    const timeout = setTimeout(() => {
      setIsPaused(false);
    }, 60000);
    
    setPauseTimeout(timeout);
  }, [pauseTimeout]);

  // Auto-scroll effect
  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(nextSlide, 8000);
    return () => clearInterval(interval);
  }, [isPaused, nextSlide]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (pauseTimeout) {
        clearTimeout(pauseTimeout);
      }
    };
  }, [pauseTimeout]);

  return {
    currentIndex,
    handleIndexChange,
    isPaused
  };
}